import { render, staticRenderFns } from "./GuidedUnassignedSubstancesSection.vue?vue&type=template&id=69f4f857&"
import script from "./GuidedUnassignedSubstancesSection.vue?vue&type=script&lang=js&"
export * from "./GuidedUnassignedSubstancesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports